import React from 'react';
import { useSuppressHydrationWarningSetting } from './useSuppressHydrationWarningSetting';
export var HydrationWarningGuard = function (_a) {
    var children = _a.children;
    var shouldSuppressHydrationWarning = useSuppressHydrationWarningSetting();
    if (shouldSuppressHydrationWarning) {
        return React.createElement("span", { suppressHydrationWarning: true }, children);
    }
    return React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=hydrationWarningGuard.js.map